export const IconPath = {
    ACCOUNT_BALANCE_WALLET: 'account_balance_wallet.svg',
    ADD_CARD: 'add_card.svg',
    AGREED:'agreed.svg'
}